module.exports = __webpack_public_path__ + "img/Balance-inspect-large.80c1bf6a.jpg";